/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { JSXElementConstructor } from "react";

// eslint-disable-next-line unused-imports/no-unused-imports
import { jsx } from "@compiled/react";

import { cssMap } from "@atlaskit/css";
import type { CustomGlyphProps } from "@atlaskit/icon/types";

const styles = cssMap({
    container: {
        display: "inline-block",
        flexShrink: 0
    },
    svg: {
        maxWidth: "100%",
        maxHeight: "100%",
        verticalAlign: "bottom",
        pointerEvents: "none"
    }
});

const ITSupportGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="33"
        viewBox="0 0 31 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.53125 6.25V32.125L8.025 25.7H30.5187V6.25H0.53125Z"
            fill="#FCA700"
        />
        <path
            d="M13.8496 7.01855C13.8496 5.1623 15.3309 3.6748 17.1621 3.6748C18.9934 3.6748 20.4746 5.15605 20.4746 7.01855C20.4746 7.9623 20.2496 8.39355 20.0434 8.66855C19.7996 8.9873 19.4934 9.2123 18.9559 9.60605C18.8684 9.6748 18.7684 9.74355 18.6621 9.81855C17.9934 10.3123 17.1434 10.9873 16.5059 12.1061C15.8621 13.2311 15.5059 14.6436 15.5059 16.5123H18.8184C18.8184 15.0623 19.0871 14.2561 19.3746 13.7623C19.6621 13.2561 20.0559 12.9123 20.6309 12.4873C20.6996 12.4373 20.7746 12.3811 20.8559 12.3248C21.3746 11.9498 22.1121 11.4186 22.6684 10.6873C23.3871 9.7498 23.7871 8.5748 23.7871 7.01855C23.7871 3.35605 20.8496 0.362305 17.1621 0.362305C13.4746 0.362305 10.5371 3.35605 10.5371 7.01855V8.67481H13.8496V7.01855Z"
            fill="#1868DB"
        />
        <path
            d="M17.1625 19.0063C16.0188 19.0063 15.0938 19.9313 15.0938 21.0751C15.0938 22.2188 16.0188 23.1438 17.1625 23.1438C18.3063 23.1438 19.2313 22.2188 19.2313 21.0751C19.2313 19.9313 18.3063 19.0063 17.1625 19.0063Z"
            fill="#1868DB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.575 6.25H13.9375C13.875 6.49375 13.8437 6.75625 13.8437 7.01875V8.675H10.5312V7.01875C10.5312 6.7625 10.5437 6.50625 10.575 6.25Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2312 21.0749C19.2312 22.2186 18.3062 23.1499 17.1624 23.1499C16.0187 23.1499 15.0874 22.2186 15.0874 21.0749C15.0874 19.9311 16.0187 19.0061 17.1624 19.0061C18.3062 19.0061 19.2312 19.9311 19.2312 21.0749Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.7871 7.01875C23.7871 8.58125 23.3871 9.75 22.6684 10.6875C22.1121 11.4187 21.3746 11.95 20.8559 12.325C20.7746 12.3875 20.6996 12.4375 20.6309 12.4875C20.0559 12.9187 19.6621 13.2625 19.3746 13.7687C19.0871 14.2687 18.8184 15.075 18.8184 16.5188H15.5059C15.5059 14.65 15.8559 13.2375 16.4996 12.1187C17.1434 11 17.9934 10.325 18.6559 9.825C18.7621 9.75 18.8621 9.68125 18.9496 9.6125C19.4934 9.2125 19.7934 8.99375 20.0371 8.675C20.2496 8.39375 20.4746 7.9625 20.4746 7.01875C20.4746 6.75625 20.4434 6.49375 20.3809 6.25H23.7434C23.7746 6.50625 23.7871 6.7625 23.7871 7.01875Z"
            fill="#AE2A19"
        />
    </svg>
);

const DesignGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="34"
        viewBox="0 0 35 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M27.6437 19.644C27.7437 19.0877 27.7938 18.4877 27.7938 17.8627C27.7938 17.2377 27.7438 16.6252 27.6375 16.0565C27.0313 12.6877 24.6938 10.6127 21.4062 10.0752C20.8438 9.98149 20.2563 9.93774 19.65 9.93774C19.0438 9.93774 18.4 9.98775 17.8188 10.0877C14.5375 10.6377 12.2 12.7065 11.5938 16.0565C11.4938 16.6252 11.4375 17.2252 11.4375 17.8627C11.4375 18.5002 11.4875 19.0877 11.5875 19.644C12.1875 22.9877 14.525 25.0627 17.8188 25.6127C18.4 25.7127 19.0125 25.7627 19.65 25.7627C20.2875 25.7627 20.85 25.719 21.4062 25.6252C24.6938 25.0877 27.0375 23.0127 27.6375 19.644H27.6437Z"
            fill="#FCA700"
        />
        <path
            d="M0.556152 16.9752L10.3062 0.262695L20.0562 16.9752H0.556152Z"
            fill="#BF63F3"
        />
        <path
            d="M16.2687 10.4875C13.8062 11.35 12.0937 13.2563 11.5937 16.0563C11.5375 16.3563 11.5 16.6563 11.4688 16.975H20.05L16.2687 10.4875Z"
            fill="#AE2A19"
        />
        <path
            d="M34.3748 19.3252H20.6748V33.0252H34.3748V19.3252Z"
            fill="#82B536"
        />
        <path
            d="M20.6748 19.3311V25.7186C20.9248 25.6936 21.1686 25.6623 21.4123 25.6248C24.6998 25.0936 27.0373 23.0123 27.6436 19.6436C27.6623 19.5436 27.6811 19.4373 27.6936 19.3311H20.6748Z"
            fill="#AE2A19"
        />
    </svg>
);

const SoftwareDevelopmentGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="31"
        viewBox="0 0 35 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M34.9626 0.581299H0.0375977V23.45H34.9626V0.581299Z"
            fill="#BF63F3"
        />
        <path
            d="M26.8816 26.5812V30.4687H8.11914V26.5812H14.3691V19.6062H20.6316V26.5812H26.8816Z"
            fill="#FCA700"
        />
        <path
            d="M20.6316 19.6062H14.3691V23.4562H20.6316V19.6062Z"
            fill="#AE2A19"
        />
        <path
            d="M17.4997 17.4438C20.4959 17.4438 22.9247 15.0149 22.9247 12.0188C22.9247 9.02261 20.4959 6.59375 17.4997 6.59375C14.5036 6.59375 12.0747 9.02261 12.0747 12.0188C12.0747 15.0149 14.5036 17.4438 17.4997 17.4438Z"
            fill="white"
        />
    </svg>
);

export const MarketingGlpyh = () => (
    <svg
        css={styles.svg}
        width="40"
        height="28"
        viewBox="0 0 29 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M28.5936 0.362549L14.9561 5.8188V20.3688L28.5936 25.825V0.362549Z"
            fill="#1868DA"
        />
        <path
            d="M18.45 6.72485V19.4374H11.3187V27.6374H5.8625V19.4374H0.40625V6.72485H18.45Z"
            fill="#FCA700"
        />
        <path
            d="M18.4498 6.72485H14.9561V19.4311H18.4498V6.72485Z"
            fill="#AE2A19"
        />
    </svg>
);

export const OperationsGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="37"
        viewBox="0 0 42 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3371 0.553483L22.3053 0.585025L24.7811 7.28206L31.8316 6.13992L35.7841 13.0563L31.2273 18.5555L35.7405 24.082L31.7333 30.9669L24.7007 29.769L22.1719 36.4462L14.2037 36.4147L11.7278 29.7176L4.68588 30.8598L0.733372 23.9434L5.29013 18.4528L0.776983 12.9263L4.78412 6.04139L11.8253 7.23932L14.3541 0.562091L14.3371 0.553483ZM18.2193 25.2168C21.9344 25.2315 24.9525 22.2372 24.9672 18.5221C24.9819 14.8071 21.9876 11.7889 18.2726 11.7742C14.5575 11.7595 11.5394 14.7539 11.5247 18.4689C11.5099 22.184 14.5043 25.2021 18.2193 25.2168Z"
            fill="#82B536"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.2269 18.547L35.7836 13.0564L31.8311 6.13999L24.7807 7.28213L22.3048 0.593637L14.3366 0.562095L11.7993 7.23075L4.76661 6.03286L0.759472 12.9177L5.27262 18.4442L0.715827 23.9434L4.66834 30.8598L11.7103 29.7091L14.1947 36.4061L22.1629 36.4377L24.6917 29.7605L28.5665 30.4249L31.7329 30.9669L35.74 24.082L33.9382 21.8714L31.2269 18.547ZM18.2189 25.2169C14.5123 25.2022 11.5095 22.1841 11.5242 18.469C11.5389 14.7539 14.5656 11.7596 18.2721 11.7743C21.9786 11.789 24.9814 14.8157 24.9668 18.5222C24.9521 22.2287 21.9339 25.2316 18.2189 25.2169Z"
            fill="#FFA900"
        />
        <g style={{ mixBlendMode: "multiply" }}>
            <path
                d="M41.3728 26.2112C41.4574 25.7407 41.4997 25.2333 41.4997 24.7047C41.4997 24.1761 41.4574 23.6581 41.3675 23.1771C40.8548 20.328 38.8779 18.5731 36.0975 18.1185C35.6218 18.0392 35.1249 18.0022 34.6122 18.0022C34.0994 18.0022 33.555 18.0445 33.0634 18.1291C30.2883 18.5942 28.3114 20.3438 27.7987 23.1771C27.7141 23.6581 27.6665 24.1655 27.6665 24.7047C27.6665 25.2439 27.7088 25.7407 27.7934 26.2112C28.3008 29.0391 30.2777 30.794 33.0634 31.2592C33.555 31.3438 34.073 31.386 34.6122 31.386C35.1513 31.386 35.627 31.349 36.0975 31.2698C38.8779 30.8152 40.8601 29.0603 41.3675 26.2112H41.3728Z"
                fill="#0C66E4"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.4713 18.4998L35.7119 23.6925L35.9706 24.0099L31.9635 30.8948L31.9371 30.8903L31.7897 30.865C29.6821 30.132 28.2195 28.5139 27.7934 26.1389C27.7088 25.6685 27.6665 25.1716 27.6665 24.6325C27.6665 24.0933 27.7141 23.5859 27.7987 23.1048C28.2069 20.8492 29.5431 19.2804 31.4713 18.4998Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.225 22.6846L33.5824 28.0872L30.667 25.2185L31.9257 24.0494L33.6039 25.6975L37.9878 21.5L39.2304 22.6897L39.225 22.6846Z"
            fill="white"
        />
    </svg>
);

export const PeopleAndOtherGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="38"
        viewBox="0 0 43 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M18.3876 3.30908C8.50444 3.30908 0.5 11.3214 0.5 21.1967C0.5 28.6407 5.0469 35.0269 11.5199 37.7187V33.4007C11.5199 29.6038 14.5986 26.533 18.3876 26.533C22.1767 26.533 25.2475 29.6116 25.2475 33.4007V37.7187C31.7205 35.0348 36.2753 28.6486 36.2753 21.1967C36.2753 11.3135 28.2629 3.30908 18.3876 3.30908ZM18.3876 24.599C15.1353 24.599 12.4988 21.9624 12.4988 18.7101C12.4988 15.4578 15.1274 12.8213 18.3876 12.8213C21.6478 12.8213 24.2686 15.4499 24.2686 18.7101C24.2686 21.9703 21.6399 24.599 18.3876 24.599Z"
            fill="#BF63F3"
        />
        <path
            d="M29.447 6.64839L23.1318 9.80597L29.447 12.9635L32.6045 19.2787L35.7621 12.9635L42.0773 9.80597L35.7621 6.64839L32.6045 0.333252L29.447 6.64839Z"
            fill="#FCA700"
        />
        <path
            d="M34.9811 14.5266L32.605 19.2787L29.4475 12.9636L23.1323 9.80601L29.0607 6.83789C31.6814 8.79558 33.7497 11.4479 34.9811 14.5266Z"
            fill="#AE2A19"
        />
        <path
            d="M29.0607 6.83789L23.1323 9.80601L29.4475 12.9636L32.605 19.2787L34.9811 14.5266C33.7497 11.4479 31.6814 8.79558 29.0607 6.83789Z"
            fill="#AE2A19"
        />
    </svg>
);

export const SalesGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="34"
        viewBox="0 0 26 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M25.6161 33.4709H0V0H12.9505L25.6161 12.4757V33.4709Z"
            fill="#FCA700"
        />
        <path d="M12.9453 0V12.4388H25.5793L12.9453 0Z" fill="#1868DB" />
        <path
            d="M20.0179 16.543H12.9492V20.0773H20.0179V16.543Z"
            fill="white"
        />
        <path
            d="M8.2369 20.6681C9.53918 20.6681 10.5949 19.6124 10.5949 18.3101C10.5949 17.0079 9.53918 15.9521 8.2369 15.9521C6.93462 15.9521 5.87891 17.0079 5.87891 18.3101C5.87891 19.6124 6.93462 20.6681 8.2369 20.6681Z"
            fill="white"
        />
        <path
            d="M20.0179 25.458H12.9492V28.9924H20.0179V25.458Z"
            fill="white"
        />
        <path
            d="M8.2369 29.5832C9.53918 29.5832 10.5949 28.5275 10.5949 27.2252C10.5949 25.9229 9.53918 24.8672 8.2369 24.8672C6.93462 24.8672 5.87891 25.9229 5.87891 27.2252C5.87891 28.5275 6.93462 29.5832 8.2369 29.5832Z"
            fill="white"
        />
    </svg>
);

export const CustomerServiceGlyph = () => (
    <svg
        css={styles.svg}
        width="46"
        height="28"
        viewBox="0 0 46 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M45.5573 10.3687H11.3848V27.0656H45.5573V10.3687Z"
            fill="#BF63F3"
        />
        <path d="M34.9362 0H0.763672V16.6969H34.9362V0Z" fill="#FCA700" />
        <path
            d="M34.9358 10.3687H11.3848V16.6966H34.9358V10.3687Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2535 5.66825L6.8942 13.0275L3.0918 9.11988L4.73342 7.52736L6.92226 9.77232L12.6399 4.05469L14.2605 5.67527L14.2535 5.66825Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.4312 16.4021L36.0719 23.7614L32.2695 19.8538L33.9112 18.2612L36.1 20.5062L41.8176 14.7886L43.4382 16.4092L43.4312 16.4021Z"
            fill="white"
        />
    </svg>
);

export const FinanceGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="30"
        viewBox="0 0 36 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M35.9463 18.2911V14.6985C35.9463 13.7694 35.1039 13.0137 34.057 13.0137H12.8853C11.8385 13.0137 10.9961 13.7632 10.9961 14.6985V18.2911H35.9463Z"
            fill="#82B536"
        />
        <path
            d="M35.9463 20.6449H10.9961V28.0408C10.9961 28.9637 11.8385 29.7256 12.8853 29.7256H34.057C35.1039 29.7256 35.9463 28.9699 35.9463 28.0408V20.6449Z"
            fill="#82B536"
        />
        <path
            d="M25.7685 5.27746V1.68482C25.7685 0.75569 24.9261 0 23.8793 0H2.70759C1.66077 0 0.818359 0.749496 0.818359 1.68482V5.27746H25.7685Z"
            fill="#FCA700"
        />
        <path
            d="M25.7685 7.63125H0.818359V15.0271C0.818359 15.95 1.66077 16.7119 2.70759 16.7119H23.8793C24.9261 16.7119 25.7685 15.9562 25.7685 15.0271V7.63125Z"
            fill="#FCA700"
        />
        <path
            d="M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z"
            fill="#09326C"
        />
        <path
            d="M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z"
            fill="#AE2A19"
        />
    </svg>
);

export const HrGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="33"
        viewBox="0 0 27 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M27 5.5H0V32.9999H27V5.5Z" fill="#FCA700" />
        <path
            d="M7 27.844C7 25.6275 9.9081 23.833 13.5 23.833C17.0919 23.833 20 25.6275 20 27.844V32.9996H7V27.844Z"
            fill="#AE2A19"
        />
        <path
            d="M18 17.875C18 20.1498 15.988 22 13.5 22C11.012 22 9 20.1556 9 17.875C9 15.5943 11.012 13.75 13.5 13.75C15.988 13.75 18 15.5943 18 17.875Z"
            fill="#AE2A19"
        />
        <path
            d="M23 3.25947V10.0833H4V3.25947H9.58471C9.58471 1.45789 11.3374 0 13.5033 0C15.6692 0 17.4153 1.45789 17.4153 3.25947H23Z"
            fill="#0C66E4"
        />
        <path d="M23 5.5H4V10.0833H23V5.5Z" fill="#AE2A19" />
    </svg>
);

export const LegalGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 275 275"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M53.72 68.75L43.27 229.76H223.49L229.02 68.75H53.72Z"
            fill="#FCA700"
        />
        <path
            d="M31.3799 203.36L31.5199 186.23H200.17L207.6 203.36H31.3799Z"
            fill="#164B35"
        />
        <path
            d="M31.5199 186.23L31.3799 203.36H44.9899L46.0999 186.23H31.5199Z"
            fill="#82B536"
        />
        <path
            d="M194.57 146.02L243.17 50.7L229.24 43.79L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57Z"
            fill="#1868DB"
        />
        <path
            d="M129.43 164.74C130.22 166.72 130.29 169.1 130.74 171.52L130.83 172.09C130.91 172.46 130.99 173 131.3 173.68C131.47 174.02 131.68 174.4 132.05 174.74C132.4 175.1 132.92 175.34 133.43 175.48C134.49 175.69 135.48 175.49 136.46 175.17C138.52 174.44 139.95 172.74 141.15 171.38C142.35 169.98 143.45 168.84 144.42 168.25C145.7 167.65 147.21 167.65 148.67 167.89C150.14 168.13 151.6 168.6 153.11 169.01C156.15 169.83 159.36 170.14 162.52 169.85C162.52 169.85 164.5 169.62 166.67 169C168.85 168.41 171.22 167.53 172.28 167.03C173.6 166.39 174.42 165.87 174.55 165.58C174.68 165.28 174.08 165.22 172.56 165.52C171.04 165.8 168.64 166.57 165.14 167.41C165.05 167.4 164.76 167.43 164.72 167.39C161.04 168.32 157.29 168.13 153.72 167.12C151.91 166.62 150.01 165.89 147.75 165.7C146.63 165.61 145.42 165.68 144.21 166.1C142.99 166.52 141.99 167.26 141.17 168.01C141.36 168.04 141.2 168.32 140.97 168.45L140.91 168.25C139.92 169.33 139.16 170.28 138.4 171.05C137.65 171.82 136.92 172.41 136.2 172.76C135.56 173.08 134.52 173.33 134.01 173.27C133.74 173.24 133.63 173.22 133.43 173.06C133.23 172.89 133 172.51 132.8 172.03C132.8 172.05 133.16 172.41 133.16 172.4C132.9 171.66 132.79 170.63 132.69 169.58C132.59 168.51 132.5 167.37 132.31 166.17C132.1 164.97 131.8 163.69 131.1 162.45C130.44 161.2 129.23 160.1 127.89 159.53L126.89 159.18L126.39 159.01L125.86 158.92L124.79 158.77L123.71 158.8C123.53 158.8 123.35 158.81 123.17 158.83L122.65 158.93C122.3 159 121.95 159.07 121.61 159.15C120.97 159.4 120.27 159.58 119.69 159.91C117.24 161.11 115.2 162.81 113.34 164.59C111.48 166.38 109.77 168.28 108.07 170.1L106.8 171.45C106.72 171.51 106.77 171.49 106.67 171.48C106.59 171.42 106.59 171.44 106.59 171.36C106.69 170.78 106.8 170.2 106.9 169.62C107.79 164.8 108.86 160.11 109.85 155.68L109.8 155.76L109.78 155.71C109.49 156.51 108.82 158.84 108.23 160.98C107.65 163.12 107.16 165.07 107.16 165.07C107.35 162.03 108.1 158.89 108.98 155.73C109.87 152.57 110.82 149.39 111.63 146.28L111.85 146.38C111.13 149.07 110.68 151.47 110.54 152.47C110.87 151.27 111.23 149.92 111.63 148.46C112.04 147 112.49 145.42 112.91 143.73C113.74 140.36 114.57 136.59 114.52 132.63C114.48 130.66 114.21 128.61 113.41 126.71C112.64 124.8 111.24 123.11 109.58 122.09C108.77 121.55 107.9 121.19 107.06 120.9C106.65 120.78 106.24 120.66 105.84 120.55C105.44 120.45 105.03 120.38 104.64 120.3C103.06 120.03 101.58 120.01 100.31 120.14C100.45 120.25 101.3 120.09 102.23 120.17C102.69 120.17 103.17 120.24 103.57 120.35C103.97 120.45 104.3 120.58 104.47 120.77C101.94 120.29 99.3202 120.53 97.0202 121.14C96.9702 120.96 97.2902 120.8 97.6602 120.69C98.0302 120.6 98.4502 120.53 98.5802 120.47C98.0602 120.51 96.2302 120.75 93.7202 121.76C91.2202 122.79 88.1202 124.65 85.0802 127.33C78.9702 132.68 72.9602 141 69.1402 149.57C67.2102 153.83 65.7602 158.06 64.6002 161.79C63.4502 165.53 62.5902 168.78 61.9802 171.18C60.7802 175.98 60.6502 177.44 62.3802 172.89L62.4302 173.42C63.9102 168.63 65.1002 164.64 67.1302 159.84C67.3302 159.13 67.4002 159.07 67.2102 159C67.2502 158.81 67.3002 158.48 67.1902 158.53C66.7202 158.45 67.4302 156.97 67.6802 156.29C68.2402 156.95 69.6102 153.17 71.3702 149.12C72.2402 147.09 73.2502 145.01 74.1302 143.32C75.0202 141.64 75.7802 140.35 76.1202 139.89C76.9302 139.9 78.6802 136.25 79.8002 135.38C79.7602 135.47 79.5202 136.05 79.4902 136.13C80.0302 135.78 83.1402 131.48 86.4102 128.46C89.6402 125.39 92.8002 123.68 90.5902 125.5C93.1302 124.07 96.1002 122.77 99.3902 122.43C101.03 122.26 102.73 122.34 104.41 122.74C106.1 123.15 107.76 123.75 108.98 124.88C110.22 125.99 111.05 127.55 111.45 129.35C111.87 131.14 111.9 133.1 111.76 135.08C111.46 139.07 110.44 143.13 109.39 147.25C108.37 151.42 107.42 155.54 106.47 159.66C106 161.72 105.55 163.76 105.12 165.8C104.92 166.82 104.71 167.83 104.51 168.84C104.41 169.34 104.32 169.85 104.22 170.35L104.15 170.73L104.11 170.93L104.08 171.25C104.06 171.68 104.14 172.14 104.35 172.53C104.76 173.33 105.53 173.85 106.38 173.96C106.81 174.02 107.27 173.96 107.68 173.79C107.89 173.72 108.07 173.59 108.25 173.47C108.4 173.35 108.6 173.17 108.66 173.1C109.35 172.38 110.03 171.67 110.71 170.96C112.04 169.55 113.34 168.19 114.65 166.95C117.24 164.48 120.06 162.42 122.72 161.92L122.54 161.87C122.71 161.87 123.22 161.72 123.36 161.79C123.85 161.66 124.57 161.53 125.36 161.63C126.14 161.72 127.06 161.99 127.66 162.4C128.3 162.81 128.74 163.41 129.01 163.89C129.27 164.39 129.4 164.74 129.4 164.74H129.43ZM110.79 145.61C110.79 145.61 110.76 145.57 110.75 145.58C110.83 145.58 111.58 142.38 111.61 142.25L111.84 142.32C111.53 145.68 107.99 152.76 110.51 145.84C110.51 145.59 110.71 145.63 110.8 145.6L110.79 145.61ZM103.79 121.7C103.24 121.6 102.63 121.5 101.95 121.47C103.83 121.36 105.94 121.67 107.93 122.59C109.94 123.49 111.55 125.37 112.29 127.54C113.05 129.71 113.13 132.06 113.01 134.3C112.87 136.55 112.53 138.73 112.19 140.8C111.96 139.3 112.28 136.94 112.43 134.49C112.6 132.05 112.46 129.5 111.88 127.86C111.18 126.28 110.13 124.7 108.61 123.68C107.88 123.14 107.06 122.74 106.22 122.43C105.39 122.11 104.57 121.87 103.79 121.71V121.7ZM69.5802 152.33L69.6902 152.4L69.5902 152.65C69.5902 152.65 69.5402 152.59 69.5402 152.54C69.5402 152.49 69.5502 152.4 69.5802 152.34V152.33ZM127.83 161.64C127.37 161.48 125.5 160.81 126.88 160.87C127.21 161 128.17 161.35 127.83 161.64ZM95.3602 122.35C95.4202 122.53 94.8302 122.9 94.1902 123.16C93.5702 123.45 92.8902 123.64 92.7702 123.42C93.6202 122.98 94.4902 122.64 95.3602 122.35ZM138.7 172.93C138.97 172.13 139.12 172.61 139.48 172.62C139.31 172.72 138.78 173.16 138.76 172.92H138.69L138.7 172.93ZM149.64 167.37C149.87 167.2 150.63 167.25 150.97 167.33C151.81 167.7 150 167.62 149.64 167.37ZM170.7 167.14C170.67 166.91 171.13 166.69 171.33 166.87C171.33 167.05 170.77 167.36 170.61 167.12C170.61 167.12 170.65 167.14 170.7 167.14ZM84.0902 128.88C84.1502 127.83 86.4902 126.49 87.5102 125.51C87.6702 126.22 85.4202 127.42 84.7202 128.26C84.4502 128.51 84.2402 128.72 84.0902 128.88ZM109.97 169.04C109.5 168.65 111.82 166.87 112.4 166.09L112.56 166.27C111.61 167.34 111.14 168.06 110.01 169L109.97 169.04ZM108.64 121.87C109.3 121.92 110.03 122.71 110.49 123.11C110.37 123.24 109.83 122.87 109.32 122.57C108.84 122.23 108.37 121.95 108.64 121.86V121.87ZM112.26 144.9C111.87 144.92 112.33 143.83 112.37 143.49C112.39 143.74 112.51 144.22 112.44 144.49C112.39 144.68 112.34 144.72 112.26 144.9ZM109.43 169.96C109.06 170.36 108.67 170.78 108.28 171.2C107.9 171.58 107.44 172.14 107.16 172.27L107.07 172.05C107.13 172.01 107.19 171.97 107.25 171.92C107.32 171.86 107.44 171.73 107.53 171.63L108.12 171.02C108.51 170.61 108.89 170.19 109.28 169.79L109.43 169.97V169.96ZM106.92 166.91L107.15 166.96C107.05 168.58 106.42 168.64 106.91 166.95V166.91H106.92ZM120.33 160.26C120.17 160.33 119.91 160.44 119.76 160.51C118.68 161.07 118.79 160.78 119.2 160.45C119.61 160.12 120.32 159.77 120.33 160.25V160.26ZM131.49 164.28C131.59 164.51 131.76 164.82 131.81 165.08C132.13 166.79 131.23 165.04 131.49 164.28Z"
            fill="#333437"
        />
        <path
            d="M229.02 68.75H216.51L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57L228.66 79.16L229.02 68.75Z"
            fill="#09326C"
        />
    </svg>
);

export const SoftwareDevelopment2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g id="Frame">
            <g id="Layer 1">
                <path
                    id="Vector"
                    d="M31.6417 10.6006H8.3584V25.5076H31.6417V10.6006Z"
                    fill="#BF63F3"
                />
                <path
                    id="Vector_2"
                    d="M26.2544 27.5486V30.0827H13.7461V27.5486H17.9128V23.002H22.0878V27.5486H26.2544Z"
                    fill="#FCA700"
                />
                <path
                    id="Vector_3"
                    d="M22.0881 23.002H17.9131V25.5116H22.0881V23.002Z"
                    fill="#AE2A19"
                />
                <path
                    id="Vector_4"
                    d="M19.9995 21.5921C21.9969 21.5921 23.6161 20.0089 23.6161 18.0558C23.6161 16.1028 21.9969 14.5195 19.9995 14.5195C18.002 14.5195 16.3828 16.1028 16.3828 18.0558C16.3828 20.0089 18.002 21.5921 19.9995 21.5921Z"
                    fill="white"
                />
            </g>
        </g>
    </svg>
);

export const ProductManagementGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M13.6757 9.37109H17.5632L18.784 12.6336L22.2215 12.0628L24.1632 15.4294L21.9507 18.1211L24.1632 20.8086L22.2215 24.1753L18.7882 23.6044L17.5673 26.8669H13.6798L12.459 23.6044L9.02565 24.1753L7.08398 20.8086L9.29648 18.1211L7.08398 15.4336L9.02565 12.0669L12.4632 12.6378L13.684 9.37526L13.6757 9.37109ZM15.6173 21.3961C17.4298 21.3961 18.8965 19.9294 18.8965 18.1169C18.8965 16.3044 17.4298 14.8378 15.6173 14.8378C13.8048 14.8378 12.3382 16.3044 12.3382 18.1169C12.3382 19.9294 13.8048 21.3961 15.6173 21.3961Z"
            fill="#82B536"
        />
        <path
            d="M24.629 17.1006H27.8373L28.8456 19.7923L31.6831 19.3214L33.2873 22.1006L31.4581 24.3214L33.2831 26.5423L31.679 29.3214L28.8415 28.8506L27.8331 31.5423H24.6248L23.6165 28.8506L20.779 29.3214L19.1748 26.5423L20.9998 24.3214L19.1748 22.1006L20.779 19.3214L23.6165 19.7923L24.6248 17.1006H24.629ZM26.2331 27.0298C27.729 27.0298 28.9415 25.8173 28.9415 24.3214C28.9415 22.8256 27.729 21.6131 26.2331 21.6131C24.7373 21.6131 23.5248 22.8256 23.5248 24.3214C23.5248 25.8173 24.7373 27.0298 26.2331 27.0298Z"
            fill="#FCA700"
        />
        <path
            d="M21.9502 18.1167L24.1627 15.4292L22.221 12.0625L18.7835 12.6333L17.5627 9.375H13.6752L12.4502 12.6333L9.01686 12.0625L7.0752 15.4292L9.2877 18.1167L7.0752 20.8083L9.01686 24.175L12.4502 23.6L13.6752 26.8625H17.5627L18.7835 23.6L20.6752 23.9167L22.221 24.175L24.1627 20.8083L23.2794 19.7333L21.9502 18.1167ZM15.6169 21.3958C13.8085 21.3958 12.3377 19.9292 12.3377 18.1167C12.3377 16.3042 13.8085 14.8375 15.6169 14.8375C17.4252 14.8375 18.896 16.3083 18.896 18.1167C18.896 19.925 17.4294 21.3958 15.6169 21.3958Z"
            fill="#82B536"
        />
        <path
            d="M23.2797 19.7338L20.7839 19.3213L19.1797 22.1005L20.6755 23.9171L22.2214 24.1755L24.163 20.8088L23.2797 19.7338Z"
            fill="#AE2A19"
        />
    </svg>
);

export const Marketing2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M28.7919 10.4443L19.7002 14.0818V23.7818L28.7919 27.4193V10.4443Z"
            fill="#1868DA"
        />
        <path
            d="M22.0292 14.6855V23.1605H17.275V28.6272H13.6375V23.1605H10V14.6855H22.0292Z"
            fill="#FCA700"
        />
        <path
            d="M22.0294 14.6855H19.7002V23.1564H22.0294V14.6855Z"
            fill="#AE2A19"
        />
    </svg>
);

export const Design2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z"
            fill="#FCA700"
        />
        <path
            d="M7.37109 19.3165L13.8711 8.1748L20.3711 19.3165H7.37109Z"
            fill="#BF63F3"
        />
        <path
            d="M17.8465 14.9912C16.2048 15.5662 15.0631 16.837 14.7298 18.7037C14.6923 18.9037 14.6673 19.1037 14.6465 19.3162H20.3673L17.8465 14.9912Z"
            fill="#AE2A19"
        />
        <path
            d="M29.9165 20.8828H20.7832V30.0161H29.9165V20.8828Z"
            fill="#82B536"
        />
        <path
            d="M20.7832 20.8867V25.1451C20.9499 25.1284 21.1124 25.1076 21.2749 25.0826C23.4665 24.7284 25.0249 23.3409 25.429 21.0951C25.4415 21.0284 25.454 20.9576 25.4624 20.8867H20.7832Z"
            fill="#AE2A19"
        />
    </svg>
);

export const ProjectManagementGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M33.2743 18.1211H12.9785V28.0378H33.2743V18.1211Z"
            fill="#BF63F3"
        />
        <path
            d="M26.9667 11.9629H6.6709V21.8796H26.9667V11.9629Z"
            fill="#FCA700"
        />
        <path
            d="M26.966 18.1211H12.9785V21.8794H26.966V18.1211Z"
            fill="#AE2A19"
        />
        <path
            d="M14.6829 15.3294L10.312 19.7003L8.05371 17.3794L9.02871 16.4336L10.3287 17.7669L13.7245 14.3711L14.687 15.3336L14.6829 15.3294Z"
            fill="white"
        />
        <path
            d="M32.012 21.7044L27.6411 26.0753L25.3828 23.7544L26.3578 22.8086L27.6578 24.1419L31.0536 20.7461L32.0161 21.7086L32.012 21.7044Z"
            fill="white"
        />
    </svg>
);

export const Operations2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M16.4783 10.0306L21.0316 10.0486L22.4464 13.8755L26.4752 13.2228L28.7338 17.175L26.1299 20.3174L28.7088 23.4754L26.419 27.4096L22.4004 26.7251L20.9553 30.5407L16.4021 30.5227L14.9873 26.6958L10.9634 27.3484L8.70478 23.3962L11.3086 20.2587L8.7297 17.1007L11.0195 13.1665L15.043 13.851L16.4881 10.0355L16.4783 10.0306ZM18.6968 24.1239C20.8197 24.1323 22.5443 22.4213 22.5527 20.2984C22.5611 18.1755 20.8501 16.4508 18.7272 16.4424C16.6043 16.434 14.8796 18.1451 14.8712 20.268C14.8628 22.3909 16.5739 24.1155 18.6968 24.1239Z"
            fill="#82B536"
        />
        <path
            d="M26.1299 20.3126L28.7338 17.1751L26.4752 13.2229L22.4464 13.8755L21.0316 10.0535L16.4783 10.0355L15.0284 13.8461L11.0098 13.1616L8.71998 17.0959L11.2989 20.2539L8.69504 23.3962L10.9536 27.3485L14.9776 26.6909L16.3972 30.5178L20.9505 30.5358L22.3955 26.7203L24.6097 27.0999L26.4191 27.4097L28.7088 23.4754L27.6792 22.2123L26.1299 20.3126ZM18.6968 24.1239C16.5788 24.1156 14.8628 22.3909 14.8712 20.268C14.8796 18.1451 16.6092 16.4341 18.7272 16.4425C20.8452 16.4508 22.5611 18.1804 22.5527 20.2984C22.5443 22.4164 20.8197 24.1323 18.6968 24.1239Z"
            fill="#FFA900"
        />
        <g>
            <path
                d="M31.9279 24.6918C31.9762 24.423 32.0004 24.133 32.0004 23.831C32.0004 23.5289 31.9762 23.2329 31.9248 22.958C31.6319 21.33 30.5022 20.3272 28.9134 20.0674C28.6416 20.0221 28.3576 20.001 28.0646 20.001C27.7717 20.001 27.4605 20.0251 27.1796 20.0735C25.5939 20.3393 24.4642 21.3391 24.1712 22.958C24.1229 23.2329 24.0957 23.5229 24.0957 23.831C24.0957 24.1391 24.1199 24.423 24.1682 24.6918C24.4582 26.3078 25.5878 27.3106 27.1796 27.5764C27.4605 27.6247 27.7566 27.6489 28.0646 27.6489C28.3727 27.6489 28.6446 27.6277 28.9134 27.5824C30.5022 27.3227 31.6349 26.3199 31.9248 24.6918H31.9279Z"
                fill="#0C66E4"
            />
        </g>
        <path
            d="M26.2701 20.2856L28.6925 23.252L28.8406 23.4336L26.5508 27.3679L26.5358 27.3653L26.448 27.3503C25.2457 26.9308 24.4115 26.0066 24.1682 24.651C24.1199 24.3822 24.0957 24.0982 24.0957 23.7901C24.0957 23.482 24.1229 23.1921 24.1712 22.9172C24.4045 21.6282 25.1681 20.7317 26.2701 20.2856Z"
            fill="#AE2A19"
        />
        <path
            d="M30.7008 22.6769L27.4765 25.7641L25.8105 24.1249L26.5298 23.4568L27.4888 24.3986L29.9939 22L30.7039 22.6798L30.7008 22.6769Z"
            fill="white"
        />
    </svg>
);

export const ITSupport2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M10.0205 14.166V31.416L15.0163 27.1327H30.0122V14.166H10.0205Z"
            fill="#FCA700"
        />
        <path
            d="M18.8997 14.6787C18.8997 13.4412 19.8872 12.4495 21.1081 12.4495C22.3289 12.4495 23.3164 13.437 23.3164 14.6787C23.3164 15.3079 23.1664 15.5954 23.0289 15.7787C22.8664 15.9912 22.6622 16.1412 22.3039 16.4037C22.2456 16.4495 22.1789 16.4954 22.1081 16.5454C21.6622 16.8745 21.0956 17.3245 20.6706 18.0704C20.2414 18.8204 20.0039 19.762 20.0039 21.0079H22.2122C22.2122 20.0412 22.3914 19.5037 22.5831 19.1745C22.7747 18.837 23.0372 18.6079 23.4206 18.3245C23.4664 18.2912 23.5164 18.2537 23.5706 18.2162C23.9164 17.9662 24.4081 17.612 24.7789 17.1245C25.2581 16.4995 25.5247 15.7162 25.5247 14.6787C25.5247 12.237 23.5664 10.2412 21.1081 10.2412C18.6497 10.2412 16.6914 12.237 16.6914 14.6787V15.7829H18.8997V14.6787Z"
            fill="#1868DB"
        />
        <path
            d="M21.1087 22.6709C20.3462 22.6709 19.7295 23.2876 19.7295 24.0501C19.7295 24.8126 20.3462 25.4292 21.1087 25.4292C21.8712 25.4292 22.4878 24.8126 22.4878 24.0501C22.4878 23.2876 21.8712 22.6709 21.1087 22.6709Z"
            fill="#1868DB"
        />
        <path
            d="M16.7167 14.166H18.9583C18.9167 14.3285 18.8958 14.5035 18.8958 14.6785V15.7827H16.6875V14.6785C16.6875 14.5077 16.6958 14.3368 16.7167 14.166Z"
            fill="#AE2A19"
        />
        <path
            d="M22.4871 24.0491C22.4871 24.8116 21.8704 25.4324 21.1079 25.4324C20.3454 25.4324 19.7246 24.8116 19.7246 24.0491C19.7246 23.2866 20.3454 22.6699 21.1079 22.6699C21.8704 22.6699 22.4871 23.2866 22.4871 24.0491Z"
            fill="#AE2A19"
        />
        <path
            d="M25.5247 14.6785C25.5247 15.7202 25.2581 16.4993 24.7789 17.1243C24.4081 17.6118 23.9164 17.966 23.5706 18.216C23.5164 18.2577 23.4664 18.291 23.4206 18.3243C23.0372 18.6118 22.7747 18.841 22.5831 19.1785C22.3914 19.5118 22.2122 20.0493 22.2122 21.0118H20.0039C20.0039 19.766 20.2372 18.8243 20.6664 18.0785C21.0956 17.3327 21.6622 16.8827 22.1039 16.5493C22.1747 16.4993 22.2414 16.4535 22.2997 16.4077C22.6622 16.141 22.8622 15.9952 23.0247 15.7827C23.1664 15.5952 23.3164 15.3077 23.3164 14.6785C23.3164 14.5035 23.2956 14.3285 23.2539 14.166H25.4956C25.5164 14.3368 25.5247 14.5077 25.5247 14.6785Z"
            fill="#AE2A19"
        />
    </svg>
);

export const HumanResourcesGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M28.2374 11.7456H11.7041V33.3456H28.2374V11.7456Z"
            fill="#FCA700"
        />
        <path
            d="M16.6831 28.9165C16.6831 27.0124 18.2248 25.4707 20.1289 25.4707C22.0331 25.4707 23.5748 27.0124 23.5748 28.9165V33.3457H16.6831V28.9165Z"
            fill="#164B35"
        />
        <path
            d="M23.0831 21.0416C23.0831 22.6707 21.7623 23.9957 20.129 23.9957C18.4956 23.9957 17.1748 22.6749 17.1748 21.0416C17.1748 19.4082 18.4956 18.0874 20.129 18.0874C21.7623 18.0874 23.0831 19.4082 23.0831 21.0416Z"
            fill="#164B35"
        />
        <path
            d="M25.908 9.95391V15.0831H14.0288V9.95391H17.5205C17.5205 8.59974 18.6163 7.50391 19.9705 7.50391C21.3246 7.50391 22.4163 8.59974 22.4163 9.95391H25.908Z"
            fill="#82B536"
        />
        <path
            d="M25.908 11.7456H14.0288V15.0831H25.908V11.7456Z"
            fill="#164B35"
        />
    </svg>
);

export const CustomerSuccess2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M23.2917 24.4C22.6583 28.5625 18.7708 31.425 14.6083 30.7917C10.4458 30.1583 7.58333 26.2708 8.21667 22.1083C8.85 17.9458 12.7375 15.0833 16.9 15.7167C21.0625 16.35 23.925 20.2375 23.2917 24.4ZM14.9208 21.475C15.0125 20.8792 14.6042 20.325 14.0083 20.2333C13.4125 20.1417 12.8583 20.55 12.7667 21.1458C12.675 21.7417 13.0833 22.2958 13.6792 22.3875C14.275 22.4792 14.8292 22.0708 14.9208 21.475ZM19.2292 22.1292C19.3208 21.5333 18.9125 20.9792 18.3167 20.8875C17.7208 20.7958 17.1667 21.2042 17.075 21.8C16.9833 22.3958 17.3917 22.95 17.9875 23.0417C18.5833 23.1333 19.1375 22.725 19.2292 22.1292ZM13.3083 25.05L12.825 24.3917L11.5083 25.3583L11.9917 26.0167C13.5208 28.0917 16.4417 28.5375 18.5208 27.0083L19.1792 26.525L18.2125 25.2083L17.5542 25.6917C16.2042 26.6833 14.3042 26.3958 13.3125 25.0458L13.3083 25.05Z"
            fill="#1868DB"
        />
        <path
            d="M22.8419 9.2748C18.7044 10.0498 15.9752 14.0331 16.7502 18.1748C17.5252 22.3123 21.5085 25.0415 25.646 24.2665C29.7835 23.4915 32.5169 19.5081 31.7419 15.3706C30.9669 11.2331 26.9794 8.50396 22.8419 9.2748ZM25.8835 13.6915C26.4752 13.579 27.0419 13.9706 27.1544 14.5623C27.2669 15.154 26.8752 15.7206 26.2835 15.8331C25.6919 15.9456 25.1252 15.554 25.0127 14.9623C24.9002 14.3706 25.2919 13.804 25.8835 13.6915ZM21.6002 14.4915C22.1919 14.379 22.7585 14.7706 22.871 15.3623C22.9835 15.954 22.5919 16.5206 22.0002 16.6331C21.4085 16.7456 20.8419 16.354 20.7294 15.7623C20.6169 15.1706 21.0085 14.604 21.6002 14.4915ZM25.2335 22.054C23.1585 22.4415 21.1669 21.079 20.7794 19.0123L28.2752 17.6081C28.6627 19.679 27.296 21.6665 25.2294 22.054H25.2335Z"
            fill="#82B536"
        />
        <path
            d="M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z"
            fill="#09326C"
        />
        <path
            d="M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z"
            fill="#09326C"
        />
    </svg>
);

export const Legal2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M31.5832 13.6997H8.4165V16.9455H31.5832V13.6997Z"
            fill="#1868DB"
        />
        <path
            d="M31.5832 26.6914H8.4165V29.9372H31.5832V26.6914Z"
            fill="#1868DB"
        />
        <path
            d="M13.9248 29.9375V16.9458H10.1331V29.9375H13.9248Z"
            fill="#1868DB"
        />
        <path
            d="M21.8955 29.9375V16.9458H18.1038V29.9375H21.8955Z"
            fill="#1868DB"
        />
        <path
            d="M29.8291 29.9375V16.9458H26.0374V29.9375H29.8291Z"
            fill="#1868DB"
        />
        <path
            d="M19.9998 8.4165L8.4165 16.9457H31.5832L19.9998 8.4165Z"
            fill="#82B536"
        />
        <path
            d="M31.5832 16.9455H8.4165L12.8248 13.6997H27.1748L31.5832 16.9455Z"
            fill="#09326C"
        />
        <path
            d="M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z"
            fill="#1868DB"
        />
        <path
            d="M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z"
            fill="#1868DB"
        />
        <path
            d="M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z"
            fill="#1868DB"
        />
        <path
            d="M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z"
            fill="#09326C"
        />
        <path
            d="M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z"
            fill="#09326C"
        />
        <path
            d="M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z"
            fill="#09326C"
        />
    </svg>
);

export const Finance2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M31.9459 22.2458V19.8291C31.9459 19.2041 31.3793 18.6958 30.6751 18.6958H16.4334C15.7293 18.6958 15.1626 19.2 15.1626 19.8291V22.2458H31.9459Z"
            fill="#BF63F3"
        />
        <path
            d="M31.9459 23.8291H15.1626V28.8041C15.1626 29.425 15.7293 29.9375 16.4334 29.9375H30.6751C31.3793 29.9375 31.9459 29.4291 31.9459 28.8041V23.8291Z"
            fill="#BF63F3"
        />
        <path
            d="M25.1002 13.4919V11.0752C25.1002 10.4502 24.5336 9.94189 23.8294 9.94189H9.58773C8.88356 9.94189 8.31689 10.4461 8.31689 11.0752V13.4919H25.1002Z"
            fill="#FCA700"
        />
        <path
            d="M25.1002 15.0752H8.31689V20.0502C8.31689 20.6711 8.88356 21.1836 9.58773 21.1836H23.8294C24.5336 21.1836 25.1002 20.6752 25.1002 20.0502V15.0752Z"
            fill="#FCA700"
        />
        <path
            d="M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z"
            fill="#09326C"
        />
        <path
            d="M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z"
            fill="#AE2A19"
        />
    </svg>
);

export const Sales2Glyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M30.1166 33.2749H9.8833V6.8374H20.1125L30.1166 16.6916V33.2749Z"
            fill="#FCA700"
        />
        <path
            d="M20.1084 6.8374V16.6624H30.0876L20.1084 6.8374Z"
            fill="#1868DB"
        />
        <path
            d="M25.6917 19.9043H20.1084V22.696H25.6917V19.9043Z"
            fill="white"
        />
        <path
            d="M16.3874 23.1625C17.416 23.1625 18.2499 22.3286 18.2499 21.3C18.2499 20.2714 17.416 19.4375 16.3874 19.4375C15.3588 19.4375 14.5249 20.2714 14.5249 21.3C14.5249 22.3286 15.3588 23.1625 16.3874 23.1625Z"
            fill="white"
        />
        <path
            d="M25.6917 26.9458H20.1084V29.7375H25.6917V26.9458Z"
            fill="white"
        />
        <path
            d="M16.3874 30.204C17.416 30.204 18.2499 29.3701 18.2499 28.3415C18.2499 27.3129 17.416 26.479 16.3874 26.479C15.3588 26.479 14.5249 27.3129 14.5249 28.3415C14.5249 29.3701 15.3588 30.204 16.3874 30.204Z"
            fill="white"
        />
    </svg>
);

export const DataScienceGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M9.1792 9.18311V26.7998H26.7959V9.18311H9.1792ZM16.7292 12.9664H23.0209V14.8539H16.7292V12.9664ZM16.7292 17.0456H23.0209V18.9331H16.7292V17.0456ZM13.5875 12.6414C14.2792 12.6414 14.8459 13.2081 14.8459 13.8998C14.8459 14.5914 14.2792 15.1581 13.5875 15.1581C12.8959 15.1581 12.3292 14.5956 12.3292 13.8998C12.3292 13.2039 12.8917 12.6414 13.5875 12.6414ZM13.5875 16.7331C14.2792 16.7331 14.8459 17.2956 14.8459 17.9914C14.8459 18.6873 14.2792 19.2498 13.5875 19.2498C12.8959 19.2498 12.3292 18.6873 12.3292 17.9914C12.3292 17.2956 12.8917 16.7331 13.5875 16.7331Z"
            fill="#1868DB"
        />
        <path
            d="M29.1873 20.0498V22.9706H16.729V28.9081H29.1873V32.4165L35.3665 26.229L29.1873 20.0498Z"
            fill="#BF63F3"
        />
        <path
            d="M16.729 22.9707V26.7999H26.7957V22.9707H16.729Z"
            fill="#09326C"
        />
    </svg>
);

export const OtherGlyph = () => (
    <svg
        css={styles.svg}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M18.2215 11.0342C12.574 11.0342 8 15.6127 8 21.2557C8 25.5094 10.5982 29.1586 14.2971 30.6968V28.2294C14.2971 26.0597 16.0563 24.305 18.2215 24.305C20.3867 24.305 22.1414 26.0642 22.1414 28.2294V30.6968C25.8403 29.1631 28.443 25.5139 28.443 21.2557C28.443 15.6081 23.8645 11.0342 18.2215 11.0342ZM18.2215 23.1998C16.3631 23.1998 14.8564 21.6932 14.8564 19.8348C14.8564 17.9763 16.3585 16.4697 18.2215 16.4697C20.0845 16.4697 21.5821 17.9718 21.5821 19.8348C21.5821 21.6977 20.08 23.1998 18.2215 23.1998Z"
            fill="#BF63F3"
        />
        <path
            d="M24.5408 12.9421L20.9321 14.7465L24.5408 16.5508L26.3451 20.1595L28.1494 16.5508L31.7581 14.7465L28.1494 12.9421L26.3451 9.3335L24.5408 12.9421Z"
            fill="#FCA700"
        />
        <path
            d="M27.7034 17.4438L26.3456 20.1593L24.5413 16.5507L20.9326 14.7464L24.3202 13.0503C25.8178 14.169 26.9997 15.6846 27.7034 17.4438Z"
            fill="#AE2A19"
        />
        <path
            d="M24.3202 13.0503L20.9326 14.7464L24.5413 16.5507L26.3456 20.1593L27.7034 17.4438C26.9997 15.6846 25.8178 14.169 24.3202 13.0503Z"
            fill="#AE2A19"
        />
    </svg>
);

export const SoftwareDevleopmentHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M47.4626 15.5811H12.5376V38.4498H47.4626V15.5811Z"
            fill="#BF63F3"
        />
        <path
            d="M39.3811 41.581V45.4685H20.6187V41.581H26.8687V34.606H33.1311V41.581H39.3811Z"
            fill="#FCA700"
        />
        <path
            d="M33.1312 34.606H26.8687V38.456H33.1312V34.606Z"
            fill="#AE2A19"
        />
        <path
            d="M30.0002 32.4438C32.9963 32.4438 35.4252 30.0149 35.4252 27.0188C35.4252 24.0226 32.9963 21.5938 30.0002 21.5938C27.0041 21.5938 24.5752 24.0226 24.5752 27.0188C24.5752 30.0149 27.0041 32.4438 30.0002 32.4438Z"
            fill="white"
        />
    </svg>
);

export const ProductManagementHeaderGylph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.0125 14.0562H26.8438L28.675 18.9499L33.8313 18.0937L36.7438 23.1437L33.425 27.1812L36.7438 31.2124L33.8313 36.2624L28.6812 35.4062L26.85 40.2999H21.0188L19.1875 35.4062L14.0375 36.2624L11.125 31.2124L14.4437 27.1812L11.125 23.1499L14.0375 18.0999L19.1938 18.9562L21.025 14.0624L21.0125 14.0562ZM23.925 32.0937C26.6437 32.0937 28.8438 29.8937 28.8438 27.1749C28.8438 24.4562 26.6437 22.2562 23.925 22.2562C21.2063 22.2562 19.0063 24.4562 19.0063 27.1749C19.0063 29.8937 21.2063 32.0937 23.925 32.0937Z"
            fill="#82B536"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.4435 25.6499H42.256L43.7685 29.6874L48.0247 28.9812L50.431 33.1499L47.6872 36.4812L50.4247 39.8124L48.0185 43.9812L43.7622 43.2749L42.2497 47.3124H37.4372L35.9247 43.2749L31.6685 43.9812L29.2622 39.8124L31.9997 36.4812L29.2622 33.1499L31.6685 28.9812L35.9247 29.6874L37.4372 25.6499H37.4435ZM39.8497 40.5437C42.0935 40.5437 43.9122 38.7249 43.9122 36.4812C43.9122 34.2374 42.0935 32.4187 39.8497 32.4187C37.606 32.4187 35.7872 34.2374 35.7872 36.4812C35.7872 38.7249 37.606 40.5437 39.8497 40.5437Z"
            fill="#FCA700"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.4248 27.175L36.7436 23.1437L33.8311 18.0938L28.6748 18.95L26.8436 14.0625H21.0123L19.1748 18.95L14.0248 18.0938L11.1123 23.1437L14.4311 27.175L11.1123 31.2125L14.0248 36.2625L19.1748 35.4L21.0123 40.2938H26.8436L28.6748 35.4L31.5123 35.875L33.8311 36.2625L36.7436 31.2125L35.4186 29.6L33.4248 27.175ZM23.9248 32.0938C21.2123 32.0938 19.0061 29.8937 19.0061 27.175C19.0061 24.4563 21.2123 22.2563 23.9248 22.2563C26.6373 22.2563 28.8436 24.4625 28.8436 27.175C28.8436 29.8875 26.6436 32.0938 23.9248 32.0938Z"
            fill="#82B536"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4186 29.5997L31.6748 28.981L29.2686 33.1497L31.5123 35.8747L33.8311 36.2622L36.7436 31.2122L35.4186 29.5997Z"
            fill="#AE2A19"
        />
    </svg>
);

export const MarketingHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M44.5936 16.3623L30.9561 21.8186V36.3686L44.5936 41.8248V16.3623Z"
            fill="#1868DA"
        />
        <path
            d="M34.45 22.7246V35.4371H27.3187V43.6371H21.8625V35.4371H16.4062V22.7246H34.45Z"
            fill="#FCA700"
        />
        <path
            d="M34.4498 22.7246H30.9561V35.4309H34.4498V22.7246Z"
            fill="#AE2A19"
        />
    </svg>
);

export const DesignHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M38.1437 31.6438C38.2437 31.0875 38.2938 30.4875 38.2938 29.8625C38.2938 29.2375 38.2438 28.625 38.1375 28.0563C37.5313 24.6875 35.1938 22.6125 31.9062 22.075C31.3438 21.9813 30.7563 21.9375 30.15 21.9375C29.5438 21.9375 28.9 21.9875 28.3188 22.0875C25.0375 22.6375 22.7 24.7063 22.0938 28.0563C21.9938 28.625 21.9375 29.225 21.9375 29.8625C21.9375 30.5 21.9875 31.0875 22.0875 31.6438C22.6875 34.9875 25.025 37.0625 28.3188 37.6125C28.9 37.7125 29.5125 37.7625 30.15 37.7625C30.7875 37.7625 31.35 37.7188 31.9062 37.625C35.1938 37.0875 37.5375 35.0125 38.1375 31.6438H38.1437Z"
            fill="#FCA700"
        />
        <path
            d="M11.0562 28.9752L20.8062 12.2627L30.5562 28.9752H11.0562Z"
            fill="#BF63F3"
        />
        <path
            d="M26.7688 22.4878C24.3063 23.3503 22.5937 25.2565 22.0937 28.0565C22.0375 28.3565 22 28.6565 21.9688 28.9753H30.55L26.7688 22.4878Z"
            fill="#AE2A19"
        />
        <path
            d="M44.8748 31.3252H31.1748V45.0252H44.8748V31.3252Z"
            fill="#82B536"
        />
        <path
            d="M31.1748 31.3315V37.719C31.4248 37.694 31.6686 37.6628 31.9123 37.6253C35.1998 37.094 37.5373 35.0128 38.1436 31.644C38.1623 31.544 38.1811 31.4378 38.1936 31.3315H31.1748Z"
            fill="#AE2A19"
        />
    </svg>
);

export const ProjectManagementGylph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M49.9125 27.1812H19.4688V42.0562H49.9125V27.1812Z"
            fill="#BF63F3"
        />
        <path
            d="M40.45 17.9438H10.0062V32.8188H40.45V17.9438Z"
            fill="#FCA700"
        />
        <path
            d="M40.45 27.1812H19.4688V32.8187H40.45V27.1812Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0249 22.9937L15.4687 29.5499L12.0812 26.0687L13.5437 24.6499L15.4937 26.6499L20.5874 21.5562L22.0312 22.9999L22.0249 22.9937Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.0187 32.5562L41.4625 39.1124L38.075 35.6312L39.5375 34.2124L41.4875 36.2124L46.5812 31.1187L48.025 32.5624L48.0187 32.5562Z"
            fill="white"
        />
    </svg>
);

export const OperationsHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.7175 15.0458L31.5474 15.0729L33.6696 20.8132L39.7128 19.8342L43.1007 25.7626L39.1948 30.4761L43.0633 35.2131L39.6286 41.1144L33.6006 40.0877L31.433 45.811L24.6031 45.784L22.481 40.0437L16.445 41.0227L13.0572 35.0943L16.963 30.3881L13.0946 25.6511L16.5292 19.7498L22.5646 20.7766L24.7321 15.0532L24.7175 15.0458ZM28.0451 36.1858C31.2295 36.1985 33.8165 33.6319 33.8291 30.4475C33.8417 27.2632 31.2751 24.6762 28.0908 24.6636C24.9064 24.651 22.3195 27.2176 22.3068 30.4019C22.2942 33.5863 24.8608 36.1732 28.0451 36.1858Z"
            fill="#82B536"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.1945 30.4688L43.1003 25.7626L39.7124 19.8343L33.6691 20.8133L31.5469 15.0803L24.7171 15.0532L22.5422 20.7692L16.5142 19.7424L13.0795 25.6438L16.948 30.3808L13.0421 35.0943L16.43 41.0227L22.466 40.0363L24.5954 45.7767L31.4253 45.8037L33.5929 40.0804L36.9141 40.6499L39.6282 41.1145L43.0628 35.2132L41.5184 33.3184L39.1945 30.4688ZM28.0447 36.1859C24.8677 36.1733 22.2938 33.5863 22.3064 30.402C22.319 27.2176 24.9133 24.6511 28.0904 24.6637C31.2674 24.6763 33.8412 27.2706 33.8287 30.4476C33.8161 33.6246 31.2291 36.1985 28.0447 36.1859Z"
            fill="#FFA900"
        />
        <g style={{ mixBlendMode: "multiply" }}>
            <path
                d="M47.8907 37.0382C47.9632 36.635 47.9995 36.2 47.9995 35.7469C47.9995 35.2939 47.9632 34.8499 47.8862 34.4376C47.4467 31.9955 45.7522 30.4913 43.3691 30.1016C42.9613 30.0337 42.5354 30.002 42.0959 30.002C41.6564 30.002 41.1898 30.0382 40.7684 30.1107C38.3898 30.5094 36.6953 32.0091 36.2558 34.4376C36.1833 34.8499 36.1425 35.2848 36.1425 35.7469C36.1425 36.2091 36.1787 36.635 36.2512 37.0382C36.6862 39.4622 38.3807 40.9664 40.7684 41.3651C41.1898 41.4376 41.6338 41.4738 42.0959 41.4738C42.558 41.4738 42.9658 41.4421 43.3691 41.3741C45.7522 40.9845 47.4513 39.4803 47.8862 37.0382H47.8907Z"
                fill="#0C66E4"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.4038 30.4282L43.0336 34.8731L43.2603 35.1511L39.8256 41.0523L39.7036 41.0316L39.6768 41.027C37.8703 40.3987 36.6167 39.0117 36.2514 36.976C36.1789 36.5728 36.1426 36.1469 36.1426 35.6848C36.1426 35.2226 36.1834 34.7877 36.2559 34.3754C36.6058 32.442 37.7511 31.0973 39.4038 30.4282Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.0498 34.0153L41.2133 38.6462L38.7144 36.1873L39.7932 35.1852L41.2317 36.5978L44.9894 33L46.0544 34.0198L46.0498 34.0153Z"
            fill="white"
        />
    </svg>
);

export const ITSupportHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0312 21.25V47.125L22.525 40.7H45.0187V21.25H15.0312Z"
            fill="#FCA700"
        />
        <path
            d="M28.35 22.0186C28.35 20.1623 29.8312 18.6748 31.6625 18.6748C33.4937 18.6748 34.975 20.1561 34.975 22.0186C34.975 22.9623 34.75 23.3936 34.5437 23.6686C34.3 23.9873 33.9937 24.2123 33.4562 24.6061C33.3687 24.6748 33.2687 24.7436 33.1625 24.8186C32.4937 25.3123 31.6437 25.9873 31.0062 27.1061C30.3625 28.2311 30.0062 29.6436 30.0062 31.5123H33.3187C33.3187 30.0623 33.5875 29.2561 33.875 28.7623C34.1625 28.2561 34.5562 27.9123 35.1312 27.4873C35.2 27.4373 35.275 27.3811 35.3562 27.3248C35.875 26.9498 36.6125 26.4186 37.1687 25.6873C37.8875 24.7498 38.2875 23.5748 38.2875 22.0186C38.2875 18.3561 35.35 15.3623 31.6625 15.3623C27.975 15.3623 25.0375 18.3561 25.0375 22.0186V23.6748H28.35V22.0186Z"
            fill="#1868DB"
        />
        <path
            d="M31.6625 34.0059C30.5188 34.0059 29.5938 34.9309 29.5938 36.0746C29.5938 37.2184 30.5188 38.1434 31.6625 38.1434C32.8063 38.1434 33.7313 37.2184 33.7313 36.0746C33.7313 34.9309 32.8063 34.0059 31.6625 34.0059Z"
            fill="#1868DB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.075 21.25H28.4375C28.375 21.4937 28.3437 21.7562 28.3437 22.0187V23.675H25.0312V22.0187C25.0312 21.7625 25.0437 21.5062 25.075 21.25Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.7313 36.0751C33.7313 37.2188 32.8063 38.1501 31.6625 38.1501C30.5188 38.1501 29.5875 37.2188 29.5875 36.0751C29.5875 34.9313 30.5188 34.0063 31.6625 34.0063C32.8063 34.0063 33.7313 34.9313 33.7313 36.0751Z"
            fill="#AE2A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.2875 22.0187C38.2875 23.5812 37.8875 24.75 37.1687 25.6875C36.6125 26.4187 35.875 26.95 35.3562 27.325C35.275 27.3875 35.2 27.4375 35.1312 27.4875C34.5562 27.9187 34.1625 28.2625 33.875 28.7687C33.5875 29.2687 33.3187 30.075 33.3187 31.5188H30.0062C30.0062 29.65 30.3562 28.2375 31 27.1187C31.6437 26 32.4937 25.325 33.1562 24.825C33.2625 24.75 33.3625 24.6813 33.45 24.6125C33.9937 24.2125 34.2937 23.9938 34.5375 23.675C34.75 23.3938 34.975 22.9625 34.975 22.0187C34.975 21.7562 34.9437 21.4937 34.8812 21.25H38.2437C38.275 21.5062 38.2875 21.7625 38.2875 22.0187Z"
            fill="#AE2A19"
        />
    </svg>
);

export const HumanResourcesHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_5039)">
            <path
                d="M42.8564 17.6187H18.0564V50.0187H42.8564V17.6187Z"
                fill="#FCA700"
            />
            <path
                d="M25.5249 43.3753C25.5249 40.519 27.8374 38.2065 30.6937 38.2065C33.5499 38.2065 35.8624 40.519 35.8624 43.3753V50.019H25.5249V43.3753Z"
                fill="#164B35"
            />
            <path
                d="M35.125 31.5626C35.125 34.0063 33.1437 35.9938 30.6937 35.9938C28.2437 35.9938 26.2625 34.0126 26.2625 31.5626C26.2625 29.1126 28.2437 27.1313 30.6937 27.1313C33.1437 27.1313 35.125 29.1126 35.125 31.5626Z"
                fill="#164B35"
            />
            <path
                d="M39.3624 14.9313V22.6251H21.5437V14.9313H26.7812C26.7812 12.9001 28.425 11.2563 30.4562 11.2563C32.4875 11.2563 34.1249 12.9001 34.1249 14.9313H39.3624Z"
                fill="#82B536"
            />
            <path
                d="M39.3624 17.6187H21.5437V22.6249H39.3624V17.6187Z"
                fill="#164B35"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_5039">
                <rect width="60" height="60" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const CustomerServiceHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_4707)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.9375 36.6C33.9875 42.8438 28.1563 47.1375 21.9125 46.1875C15.6688 45.2375 11.375 39.4063 12.325 33.1625C13.275 26.9188 19.1063 22.625 25.35 23.575C31.5938 24.525 35.8875 30.3563 34.9375 36.6ZM22.3813 32.2125C22.5188 31.3188 21.9062 30.4875 21.0125 30.35C20.1188 30.2125 19.2875 30.825 19.15 31.7188C19.0125 32.6125 19.625 33.4438 20.5188 33.5813C21.4125 33.7188 22.2438 33.1063 22.3813 32.2125ZM28.8438 33.1938C28.9813 32.3 28.3688 31.4688 27.475 31.3313C26.5813 31.1938 25.75 31.8063 25.6125 32.7C25.475 33.5938 26.0875 34.425 26.9813 34.5625C27.875 34.7 28.7063 34.0875 28.8438 33.1938ZM19.9625 37.575L19.2375 36.5875L17.2625 38.0375L17.9875 39.025C20.2813 42.1375 24.6625 42.8063 27.7813 40.5125L28.7688 39.7875L27.3188 37.8125L26.3313 38.5375C24.3063 40.025 21.4563 39.5938 19.9688 37.5688L19.9625 37.575Z"
                fill="#1868DB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.2625 13.9127C28.0563 15.0752 23.9625 21.0502 25.125 27.2627C26.2875 33.4689 32.2625 37.5627 38.4688 36.4002C44.675 35.2377 48.775 29.2627 47.6125 23.0564C46.45 16.8502 40.4688 12.7564 34.2625 13.9127ZM38.825 20.5377C39.7125 20.3689 40.5625 20.9564 40.7313 21.8439C40.9 22.7314 40.3125 23.5814 39.425 23.7502C38.5375 23.9189 37.6875 23.3314 37.5188 22.4439C37.35 21.5564 37.9375 20.7064 38.825 20.5377ZM32.4 21.7377C33.2875 21.5689 34.1375 22.1564 34.3063 23.0439C34.475 23.9314 33.8875 24.7814 33 24.9502C32.1125 25.1189 31.2625 24.5314 31.0938 23.6439C30.925 22.7564 31.5125 21.9064 32.4 21.7377ZM37.85 33.0814C34.7375 33.6627 31.75 31.6189 31.1688 28.5189L42.4125 26.4127C42.9938 29.5189 40.9438 32.5002 37.8438 33.0814H37.85Z"
                fill="#82B536"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z"
                fill="#09326C"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z"
                fill="#09326C"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_4707">
                <rect width="60" height="60" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const LegalHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_5503)">
            <path
                d="M48.375 20.5498H13.625V25.4186H48.375V20.5498Z"
                fill="#1868DB"
            />
            <path
                d="M48.375 40.0376H13.625V44.9063H48.375V40.0376Z"
                fill="#1868DB"
            />
            <path
                d="M21.8877 44.9064V25.4189H16.2002V44.9064H21.8877Z"
                fill="#1868DB"
            />
            <path
                d="M33.8438 44.9064V25.4189H28.1562V44.9064H33.8438Z"
                fill="#1868DB"
            />
            <path
                d="M45.7437 44.9064V25.4189H40.0562V44.9064H45.7437Z"
                fill="#1868DB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31 12.625L13.625 25.4187H48.375L31 12.625Z"
                fill="#82B536"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.375 25.4186H13.625L20.2375 20.5498H41.7625L48.375 25.4186Z"
                fill="#09326C"
            />
            <path
                d="M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z"
                fill="#1868DB"
            />
            <path
                d="M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z"
                fill="#1868DB"
            />
            <path
                d="M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z"
                fill="#1868DB"
            />
            <path
                d="M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z"
                fill="#09326C"
            />
            <path
                d="M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z"
                fill="#09326C"
            />
            <path
                d="M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z"
                fill="#09326C"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_5503">
                <rect
                    width="60"
                    height="60"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const FinanceHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_6742)">
            <path
                d="M48.9187 33.369V29.7439C48.9187 28.8064 48.0687 28.0439 47.0124 28.0439H25.6499C24.5937 28.0439 23.7437 28.8002 23.7437 29.7439V33.369H48.9187Z"
                fill="#BF63F3"
            />
            <path
                d="M48.9187 35.744H23.7437V43.2064C23.7437 44.1377 24.5937 44.9064 25.6499 44.9064H47.0124C48.0687 44.9064 48.9187 44.1439 48.9187 43.2064V35.744Z"
                fill="#BF63F3"
            />
            <path
                d="M38.6501 20.2376V16.6126C38.6501 15.6751 37.8001 14.9126 36.7438 14.9126H15.3813C14.3251 14.9126 13.4751 15.6688 13.4751 16.6126V20.2376H38.6501Z"
                fill="#FCA700"
            />
            <path
                d="M38.6501 22.6126H13.4751V30.0751C13.4751 31.0063 14.3251 31.7751 15.3813 31.7751H36.7438C37.8001 31.7751 38.6501 31.0126 38.6501 30.0751V22.6126Z"
                fill="#FCA700"
            />
            <path
                d="M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z"
                fill="#09326C"
            />
            <path
                d="M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z"
                fill="#AE2A19"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_6742">
                <rect
                    width="60"
                    height="60"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const SalesHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_5805)">
            <path
                d="M45.1752 49.9126H14.8252V10.2563H30.1689L45.1752 25.0376V49.9126Z"
                fill="#FCA700"
                aria-hidden="true"
            />
            <path
                d="M30.1631 10.2563V24.9938H45.1318L30.1631 10.2563Z"
                fill="#1868DB"
            />
            <path
                d="M38.5381 29.8564H30.1631V34.0439H38.5381V29.8564Z"
                fill="white"
            />
            <path
                d="M24.5818 34.7438C26.1248 34.7438 27.3756 33.4929 27.3756 31.95C27.3756 30.4071 26.1248 29.1562 24.5818 29.1562C23.0389 29.1562 21.7881 30.4071 21.7881 31.95C21.7881 33.4929 23.0389 34.7438 24.5818 34.7438Z"
                fill="white"
            />
            <path
                d="M38.5381 40.4189H30.1631V44.6064H38.5381V40.4189Z"
                fill="white"
            />
            <path
                d="M24.5818 45.3062C26.1248 45.3062 27.3756 44.0554 27.3756 42.5125C27.3756 40.9696 26.1248 39.7188 24.5818 39.7188C23.0389 39.7188 21.7881 40.9696 21.7881 42.5125C21.7881 44.0554 23.0389 45.3062 24.5818 45.3062Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_5805">
                <rect width="60" height="60" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const DataScienceHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <g clipPath="url(#clip0_1_6101)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2686 13.7749V40.1999H40.6936V13.7749H14.2686ZM25.5936 19.4499H35.0311V22.2812H25.5936V19.4499ZM25.5936 25.5687H35.0311V28.3999H25.5936V25.5687ZM20.8811 18.9624C21.9186 18.9624 22.7686 19.8124 22.7686 20.8499C22.7686 21.8874 21.9186 22.7374 20.8811 22.7374C19.8436 22.7374 18.9936 21.8937 18.9936 20.8499C18.9936 19.8062 19.8373 18.9624 20.8811 18.9624ZM20.8811 25.0999C21.9186 25.0999 22.7686 25.9437 22.7686 26.9874C22.7686 28.0312 21.9186 28.8749 20.8811 28.8749C19.8436 28.8749 18.9936 28.0312 18.9936 26.9874C18.9936 25.9437 19.8373 25.0999 20.8811 25.0999Z"
                fill="#1868DB"
            />
            <path
                d="M44.2812 30.0747V34.456H25.5938V43.3622H44.2812V48.6247L53.55 39.3435L44.2812 30.0747Z"
                fill="#BF63F3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.5938 34.4561V40.1998H40.6937V34.4561H25.5938Z"
                fill="#09326C"
            />
        </g>
        <defs>
            <clipPath id="clip0_1_6101">
                <rect width="60" height="60" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const OtherHeaderGlyph = () => (
    <svg
        css={styles.svg}
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M27.8323 16.5508C19.3609 16.5508 12.5 23.4185 12.5 31.883C12.5 38.2636 16.3973 43.7375 21.9456 46.0447V42.3436C21.9456 39.0891 24.5845 36.457 27.8323 36.457C31.08 36.457 33.7121 39.0958 33.7121 42.3436V46.0447C39.2604 43.7442 43.1645 38.2704 43.1645 31.883C43.1645 23.4117 36.2968 16.5508 27.8323 16.5508ZM27.8323 34.7993C25.0446 34.7993 22.7847 32.5394 22.7847 29.7517C22.7847 26.964 25.0378 24.7041 27.8323 24.7041C30.6267 24.7041 32.8731 26.9572 32.8731 29.7517C32.8731 32.5461 30.6199 34.7993 27.8323 34.7993Z"
            fill="#BF63F3"
        />
        <path
            d="M37.3114 19.413L31.8984 22.1195L37.3114 24.826L40.0179 30.2389L42.7244 24.826L48.1374 22.1195L42.7244 19.413L40.0179 14L37.3114 19.413Z"
            fill="#FCA700"
        />
        <path
            d="M42.0555 26.1655L40.0189 30.2388L37.3124 24.8258L31.8994 22.1193L36.9808 19.5752C39.2272 21.2532 41 23.5267 42.0555 26.1655Z"
            fill="#AE2A19"
        />
        <path
            d="M36.9808 19.5752L31.8994 22.1193L37.3124 24.8258L40.0189 30.2388L42.0555 26.1655C41 23.5267 39.2272 21.2532 36.9808 19.5752Z"
            fill="#AE2A19"
        />
    </svg>
);

export const ITSupportIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ITSupportGlyph />
        </span>
    );
};

export const DesignIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <DesignGlyph />
        </span>
    );
};

export const MarketingIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <MarketingGlpyh />
        </span>
    );
};

export const SoftwareDevelopmentIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <SoftwareDevelopmentGlyph />
        </span>
    );
};

export const OperationsIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <OperationsGlyph />
        </span>
    );
};

export const PeopleAndOtherIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <PeopleAndOtherGlyph />
        </span>
    );
};

export const SalesIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <SalesGlyph />
        </span>
    );
};

export const CustomerServiceIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <CustomerServiceGlyph />
        </span>
    );
};

export const FinanceIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <FinanceGlyph />
        </span>
    );
};

export const HrIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <HrGlyph />
        </span>
    );
};

export const LegalIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <LegalGlyph />
        </span>
    );
};

export const SoftwareDevelopmentIcon2: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <SoftwareDevelopment2Glyph />
        </span>
    );
};

export const ProductManagementIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ProductManagementGlyph />
        </span>
    );
};

export const MarketingIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Marketing2Glyph />
        </span>
    );
};

export const DesignIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Design2Glyph />
        </span>
    );
};

export const ProjectManagementIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ProjectManagementGlyph />
        </span>
    );
};

export const OperationsIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Operations2Glyph />
        </span>
    );
};

export const ITSupportIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ITSupport2Glyph />
        </span>
    );
};

export const HumanResourcesIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <HumanResourcesGlyph />
        </span>
    );
};

export const CustomerServiceIcon2: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <CustomerSuccess2Glyph />
        </span>
    );
};

export const LegalIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Legal2Glyph />
        </span>
    );
};

export const FinanceIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Finance2Glyph />
        </span>
    );
};

export const SalesIcon2: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <Sales2Glyph />
        </span>
    );
};

export const DataScienceIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <DataScienceGlyph />
        </span>
    );
};

export const OtherIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <OtherGlyph />
        </span>
    );
};

export const SoftwareDevelopmentHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <SoftwareDevleopmentHeaderGlyph />
        </span>
    );
};

export const ProductManagementHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ProductManagementHeaderGylph />
        </span>
    );
};

export const MarketingHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <MarketingHeaderGlyph />
        </span>
    );
};

export const DesignHeaderIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <DesignHeaderGlyph />
        </span>
    );
};

export const ProjectManagementHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ProjectManagementGylph />
        </span>
    );
};

export const OperationsHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <OperationsHeaderGlyph />
        </span>
    );
};

export const ITSupportHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <ITSupportHeaderGlyph />
        </span>
    );
};

export const HumanResourcesHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <HumanResourcesHeaderGlyph />
        </span>
    );
};

export const CustomerServiceHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <CustomerServiceHeaderGlyph />
        </span>
    );
};

export const LegalHeaderIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <LegalHeaderGlyph />
        </span>
    );
};

export const FinanceHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <FinanceHeaderGlyph />
        </span>
    );
};

export const SalesHeaderIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <SalesHeaderGlyph />
        </span>
    );
};

export const DataScienceHeaderIcon: JSXElementConstructor<
    CustomGlyphProps
> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <DataScienceHeaderGlyph />
        </span>
    );
};

export const OtherHeaderIcon: JSXElementConstructor<CustomGlyphProps> = () => {
    return (
        <span css={styles.container} aria-hidden={true}>
            <OtherHeaderGlyph />
        </span>
    );
};
